import type {
	AddShippingInfoEcommerce,
	BeginCheckoutEcommerce,
	GTMProduct,
	PageView,
	PurchaseEcommerce,
	ViewCartEcommerce,
	ViewItemListEcommerce,
} from "./types";
import { sendGTMEvent } from "./utils";

export const gtm = {
	pageView: (data: PageView) => {
		sendGTMEvent(data);
	},
	addToCart: (item: GTMProduct) => {
		sendGTMEvent({
			event: "add_to_cart",
			ecommerce: {
				items: [item],
				currency: item.currency,
				value: item.price,
			},
		});
	},
	removeFromCart: (item: GTMProduct) => {
		sendGTMEvent({
			event: "remove_from_cart",
			ecommerce: {
				items: [item],
				currency: item.currency,
				value: item.price,
			},
		});
	},
	viewCart: (ecommerce: ViewCartEcommerce) => {
		sendGTMEvent({
			event: "view_cart",
			ecommerce,
		});
	},
	addShippingMethod: (ecommerce: AddShippingInfoEcommerce) => {
		sendGTMEvent({
			event: "add_shipping_info",
			ecommerce,
		});
	},
	beginCheckout: (ecommerce: BeginCheckoutEcommerce) => {
		sendGTMEvent({
			event: "begin_checkout",
			ecommerce,
		});
	},
	viewItem: (item: GTMProduct) => {
		sendGTMEvent({
			event: "view_item",
			ecommerce: {
				items: [item],
				currency: item.currency,
				value: item.price,
			},
		});
	},
	viewItemList: (ecommerce: ViewItemListEcommerce) => {
		sendGTMEvent({
			event: "view_item_list",
			ecommerce,
		});
	},
	purchase: (ecommerce: PurchaseEcommerce) => {
		sendGTMEvent({
			event: "purchase",
			ecommerce,
		});
	},
};
